export enum EnumEstadoUsuarioAtlas {
  Activo = 1,
  Baja
}
